import "./financeMelaTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const FinanceMelaTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFinanceMela, setSelectedFinanceMela] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  const fetchFinanceMela = useCallback(async () => {
    if (!BASE_URL || !userId) return;

    try {
      setLoading(true);
      setError(null);

      const res = await axios.get(
        `${BASE_URL}/api/financeMela/findAllFinanceMela/${userId}`,
        {
          params: {
            page: paginationModel.page + 1,
            limit: paginationModel.pageSize,
          },
        },
      );

      setData(res.data.data || []);
      setRowCount(res.data.total || 0);
    } catch (err) {
      setError("Failed to fetch Finance Mela data.");
    } finally {
      setLoading(false);
    }
  }, [userId, BASE_URL, paginationModel]);

  useEffect(() => {
    fetchFinanceMela();
  }, [fetchFinanceMela]);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/financeMela/deleteFinanceMela/${id}`);
      fetchFinanceMela();
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = (financeMelaData) => {
    navigate("/financeMela/newFinanceMela", {
      state: { financeMela: financeMelaData },
    });
  };

  const columns = [
    { field: "_id", headerName: "ID", width: 100 },
    { field: "title", headerName: "Title", flex: 1 },
    { field: "type", headerName: "Type", width: 120 },
    { field: "melaName", headerName: "Mela", flex: 1 },
    { field: "amount", headerName: "Amount", width: 120 },
    { field: "createdDate", headerName: "Created Date", width: 140 },
    { field: "editedDate", headerName: "Edited Date", width: 140 },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <Box>
          <IconButton onClick={() => handleUpdate(params.row)}>
            <Edit />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => {
              setSelectedFinanceMela(params.row);
              setOpenDialog(true);
            }}
          >
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5">List Of Finance Mela</Typography>
        <Link to="/financeMela/newFinanceMela">
          <Button variant="contained">Add Finance Mela</Button>
        </Link>
      </div>

      {error && (
        <Typography color="error" align="center">
          {error}
        </Typography>
      )}

      <Box sx={{ flex: 1 }}>
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          pageSizeOptions={[5, 10, 20, 50]}
          loading={loading}
          autoHeight
        />
      </Box>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this Finance Mela?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button
            color="error"
            onClick={() => {
              handleDelete(selectedFinanceMela._id);
              setOpenDialog(false);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FinanceMelaTable;
